import {Navbar} from "../../components/navbar";
import {
  StyledLayout,
  StyledOnboardingMainSection,
} from "../auth-form-wrapper/auth-form-wrapper.style";

interface IPublicLayout {
  children: React.ReactNode;
}

const PublicLayout: React.FC<IPublicLayout> = ({children}) => {
  return (
    <StyledLayout>
      <Navbar />
      <StyledOnboardingMainSection>{children}</StyledOnboardingMainSection>
    </StyledLayout>
  );
};

export {PublicLayout};
